// extracted by mini-css-extract-plugin
module.exports = {"root":"bn_b9"};